import React, { memo, useState, useEffect, Suspense, lazy } from "react";
import Grid from '@techsoftware/happay-widgets/Grid';

import SetTheme from "../utils/theme";
import * as Common from "../utils/common";

import LinkBreak from  "../assets/images/linkBreak.svg";
import NoInternet from  "../assets/images/noInternet.png";

import { Mixpanel, MIXPANEL_TOKEN } from "../helpers/mixpanel";
import { isMobile, getDeviceType } from "../helpers/widgetFunctions";

const EmptyStateErrPage = lazy(() => import('./common/emptyStateErrPage'));
const LandingPage = lazy(() => import('./landingPage'));

function Root(props) {
  const [state, setState] = useState({
    errMsg: "",
    errImg: ""
  });

  const {errMsg, errImg} = state;

  const {initData = null} = props;

  useEffect(() => {
    // add online offline listner
    addOnlineOfflineEvent();  

    if(initData) {
      setInitData();
    } else {
      // Call Init API
      callIntApi();
    }

    //Unmounting
    return () => {
      removeOnlineOfflineEvent();
    }
  }, [initData]);

  const addOnlineOfflineEvent = () => {
    window.addEventListener('offline', () => {
      setState({
        ...state,
        errImg: NoInternet,
        errMsg: 'Seems like you are offline! Check your internet connection.'
      });
    });
  
    window.addEventListener('online', () => {
      if(initData) {
        if(!("session_id" in initData)) {
          window.location.reload();
        } else {
          setState({
            ...state,
            errMsg: '',
            errImg: ""
          });
          props.openSnackbar("Keep working! Connection is back…");
        }
      }
    });
  }
  
  const removeOnlineOfflineEvent = () => {
    window.removeEventListener('online', () => {});
    window.removeEventListener('offline', () => {});
  }  

  const callIntApi = () => {
    const {pathname = ""} = window?.location;
    const splitPathname = pathname?.split("/");
    let channelName = splitPathname?.[1];
    let userToken = splitPathname?.[2];
    
    let deviceType = 'web';
    if(isMobile) {
      deviceType = getDeviceType();
    }

    if(userToken) {
        sessionStorage.removeItem("happayVideoKyc.userToken");
        sessionStorage.removeItem("happayVideoKyc.channelName");
        sessionStorage.setItem("happayVideoKyc.userToken", userToken);
        sessionStorage.setItem("happayVideoKyc.channelName", channelName.toUpperCase());
    } else {
        userToken = sessionStorage.getItem("happayVideoKyc.userToken");
        channelName = sessionStorage.getItem("happayVideoKyc.channelName");
    }

    if(!userToken) {
      setState({
        ...state,
        errImg: LinkBreak,
        errMsg: 'This link seems to be broken!'
      });

    } else {
      const reqData = {
        user_token: userToken,
      };
      props.getCurrentState(reqData);

      let mixPanleToken = MIXPANEL_TOKEN;
      if(process.env.NODE_ENV === "development" || channelName?.toLowerCase()?.includes(
        "hdfc"
      )) {
        mixPanleToken = 'xyz'
      }

      Mixpanel.init(mixPanleToken);

      const mixpanelRegObj = {
        channel_name: channelName,
        user_token: userToken,
        device_type: deviceType,
      };
      console.log("HAHA:: register: ", mixpanelRegObj)
      Mixpanel.register(mixpanelRegObj);
    }
  }

  const setInitData = () => {
    if(initData) {
      if(initData.error_code === 1004 || !("session_id" in initData)) {
        setState({
            ...state,
            errImg: LinkBreak,
            errMsg: 'This link seems to be broken!' || msg, 
        });
      } 
      // else if(!("session_id" in initData)) {
      //   setState({
      //     ...state,
      //     errImg: NoInternet,
      //     errMsg: 'Seems like you are offline! Check your internet connection.'
      //   });
      // }
      else if("session_id" in initData) {
        const {css = {}} = initData;
        SetTheme(css);

        const channelName = sessionStorage.getItem("happayVideoKyc.channelName");

        const sessionId = initData?.session_id || '';
        const userId = initData?.user_id || '';

        Mixpanel.identify(userId);

        let deviceType = 'web';
        if(isMobile) {
          deviceType = getDeviceType();
        }    
        const userToken = sessionStorage.getItem("happayVideoKyc.userToken");
        
        const mixpanelIdentityObj = {
          $session_id: sessionId,
          $user_token: userToken,
          $channel_name: channelName,
          $device_type: deviceType,
          $last_login: new Date(),
        }
        console.log("HAHA:: set: ", mixpanelIdentityObj)
        // Set user properties
        Mixpanel.people.set(mixpanelIdentityObj);
            
        Common.initData(initData);
        //for removing user token from url
        window.history.pushState({}, null, "/");
      }
    }
  };

  // if(props?.initData?.video_kyc_allowed) {
  //   if( ( (new Date() > new Date("October 24, 2021 03:00:00")) && 
  //       (new Date() < new Date("October 24, 2021 11:00:00")) ) ) {
  //     return (
  //       <Suspense fallback={<div></div>}>
  //         <EmptyStateErrPage 
  //           imgSrc={LinkBreak}
  //           errMsg={<div>
  //             <div>We will be back shortly!</div>
  //             <div>Our system is currently undergoing maintenance and will be back by 11 am.</div> 
  //             <div>Thank you for your support and understanding.</div>
  //           </div>} 
  //         />
  //       </Suspense>
  //     )
  //   }
  // }

  return (
    <Grid
      className="parentContainer"
    >
      {errMsg !== "" ?
        <Suspense fallback={<div></div>}>
          <EmptyStateErrPage 
            imgSrc={errImg}
            errMsg={errMsg} 
          />
        </Suspense>
        :
        initData && ("session_id" in initData) &&
        <Suspense fallback={<div></div>}>
          <LandingPage {...props} />
        </Suspense>
      }
    </Grid>
  );
}

export default memo(Root);
